import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ModalError from 'src/components/shared/modals/Error/Error';
import ModalCreditAnalysis from 'src/components/shared/modals/creditAnalysis/ModalCreditAnalysis';
//import ErrorCreditAnalysis from 'src/components/modals/creditAnalysis/ModalCreditAnalysis';
import {
  creditAnalysis,
  literaxCreditAnalysis,
  satwsInfo,
  selectIsApproved,
  setLoadingMessage,
  setLoadingState
} from 'src/store/User/user.slice';
import {
  PersonalInformationContainer,
  Banner,
  FormSection,
  ContactData,
  ConsultCredit,
  BiometricsSection,
  Container
} from './biometrics.styles';
import { environment, url } from 'src/environments';
import Card from 'src/utilities/UILibrary/UI/Card/Card';
import { InputField } from 'src/utilities/UILibrary/Forms/InputField/InputField';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { MetamapButton } from 'src/components/shared/ MetamapButton/MetamapButton';
import { RootState, useAppThunkDispatch } from 'src/store/store';
import { FormValues } from './biometrics.types';
import { Checkbox } from 'src/utilities/UILibrary/Forms/Checkbox/Checkbox';
import { InputUpload } from 'src/utilities/UILibrary/Forms/InputUpload/InputUpload';
import { fileToBase64 } from 'src/functions/fileToBase64';
import { useManageSteps } from 'src/hooks/useManageSteps';
import Modal from 'src/utilities/UILibrary/Feedback/Modal/Modal';
import { fetchPersonalInformation } from 'src/store/Profile/profile.slice';

const loadingMessage =
  'Estimado usuario, estamos procesando tu información, esto puede tardar unos minutos. Por favor, no cierres esta ventana.';

export default function BiometricsApplicant() {
  //SATWS
  const [type, setType] = useState<string>();
  const [showCreditModal, setShowCreditModal] = useState(false);
  const user = useSelector((state: RootState) => state.user.currentUser);
  const personalInformation = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: RootState) => state.profile?.personalInformation as any
  );
  const isApproved = useSelector(selectIsApproved);
  const [showInput, setShowInput] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppThunkDispatch();
  const [metamapComplete, setMetamapComplete] = useState(false);
  const [messageId, setMessageId] = useState<string>();
  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    setError
  } = useForm<FormValues>();
  const { nextStep } = useManageSteps();

  // This useEffect is TODO
  useEffect(() => {
    if (isApproved) {
      navigate('/solicitante/onboarding-creditInfo');
    }
  }, [isApproved, navigate]);

  const closeFlow = () => {
    navigate('/');
  };

  //FIle to base64
  const handleFile = async (file: File) => {
    if (!file) return;

    try {
      const base64String = await fileToBase64(file);
      return base64String;
      // Aquí puedes hacer uso del base64String, por ejemplo, enviarlo a un servidor
    } catch (error) {
      console.error('Error al convertir el archivo a Base64:', error);
    }
  };

  const metadata = {
    id: user.id,
    typeOfUser: 'applicant',
    fixedLanguage: 'es'
  };
  const clientid = process.env.REACT_APP_METAMAP_CLIENTID;
  const flowid = process.env.REACT_APP_METAMAP_FLOWID;

  useEffect(() => {
    let retries = 0;
    const maxRetries = 8;
    // eslint-disable-next-line no-console, prefer-const
    let intervalId: string | number | NodeJS.Timeout | undefined;

    const checkData = async () => {
      const response = await dispatch(fetchPersonalInformation(user.id));
      const personalInformation = response?.payload?.personalInformation;
      const { fullName, email, dateOfBirth, CURP } = personalInformation || {
        fullName: undefined,
        email: undefined,
        dateOfBirth: undefined,
        CURP: undefined
      };

      if (fullName && email && dateOfBirth && CURP) {
        clearInterval(intervalId);
        setMetamapComplete(true);
        setShowModal(true);
      } else if (retries >= maxRetries) {
        clearInterval(intervalId);
        console.error('Retrive data from Metamap failed');
        setMetamapComplete(true);
      } else {
        retries++;
      }
    };

    intervalId = setInterval(checkData, 1000);
    return () => clearInterval(intervalId); // Cleanup function to clear the interval when component unmounts
  }, [dispatch, user.id]);

  const handleMetamapFinish = async () => {
    let retries = 0;
    const maxRetries = 8;
    setMetamapComplete(true);

    const checkData = async () => {
      const response = await dispatch(fetchPersonalInformation(user.id));
      const personalInformation = response?.payload?.personalInformation;
      const { fullName, email, dateOfBirth, CURP } = personalInformation || {
        fullName: undefined,
        email: undefined,
        dateOfBirth: undefined,
        CURP: undefined
      };
      // Check if the data you need is in the response, if so, stop the interval.
      if (fullName && email && dateOfBirth && CURP) {
        clearInterval(intervalId);
        setMetamapComplete(true);
        setShowModal(true);
      } else if (retries >= maxRetries) {
        clearInterval(intervalId);
        console.error('Retrive data from Metamap failed');
        setMetamapComplete(true);
      } else {
        retries++;
        setTimeout(checkData, 1000);
      }
    };

    const intervalId = setInterval(checkData, 1000);
    checkData();
  };

  const handleType = (value: string | number | readonly string[]) => setType(value.toString());

  const handleValidateCode: SubmitHandler<FormValues> = async (data) => {
    const { certificate, privateKey, finspheraPassword } = data;
    const codeInput = {
      id: user.id,
      messageId: messageId,
      code: finspheraPassword,
      timestamp: Date.now(),
      typeOfUser: 'applicant'
    };
    let validationCode;

    dispatch(setLoadingState(true));
    dispatch(setLoadingMessage(loadingMessage));
    try {
      validationCode = await axios.post(
        `${url}/${environment}/admin/email/validate-otp`,
        codeInput
      );
    } catch (error) {
      dispatch(setLoadingState(false));
      console.error(error);
    }
    if (!validationCode) {
      dispatch(setLoadingState(false));
      //Definir lógica para notificar que ocurrió un error y que solicite reenviar código de verif. y cuántas veces lo puede hacer.
      return;
    }
    const parsedBody = JSON.parse(validationCode.data.body);
    if (!parsedBody.isVerified) {
      dispatch(setLoadingState(false));
      return setError('finspheraPassword', {
        type: 'custom',
        message: 'Ups, el código que ingresaste es incorrecto.'
      });
    }
    //
    const certificateBase64 = await handleFile(certificate);
    const privateKeyBase64 = await handleFile(privateKey);
    const creditBody = {
      id: user.id,
      typeOfUser: 'applicant',
      timestamp: Date.now()
    };
    //Esto se manda a satws
    let body = {};
    if (type === 'ciec') {
      body = {
        type: type,
        rfc: data.RFC,
        password: data.password,
        id: user.id,
        typeOfUser: 'applicant'
      };
    }

    if (type === 'efirma') {
      body = {
        type: type,
        password: data.password,
        id: user.id,
        typeOfUser: 'applicant',
        certificate: certificateBase64,
        privateKey: privateKeyBase64,
        rfc: data.RFC
      };
    }
    await dispatch(satwsInfo(body));
    await dispatch(creditAnalysis(body));
    await dispatch(literaxCreditAnalysis(creditBody));
    dispatch(setLoadingState(false));
    await nextStep();
    navigate('/solicitante/onboarding-creditInfo');
  };

  const onSubmit: SubmitHandler<FormValues> = async () => {
    // HARD CODED
    //Función para enviar código de validación al email
    const input = {
      id: user.id,
      typeOfUser: 'applicant',
      typeMessage: 'checkCdC',
      email: user.email,
      timestamp: Date.now()
    };

    axios
      .post(`${url}/${environment}/admin/send-otp-to-email`, input)
      .then((response) => {
        const parsedBody = JSON.parse(response.data.body);
        setMessageId(parsedBody.messageId);
        setShowInput(true);
      })
      .catch((error) => {
        console.error(error);
      });
    setShowInput(true);
  };

  const selectOptions = [
    { value: 'ciec', label: 'CIEC' },
    { value: 'efirma', label: 'e.firma' }
  ];

  return (
    <PersonalInformationContainer>
      <Modal onClose={() => setShowModal(false)} isOpen={showModal}>
        <Modal.Header isCentered>
          <h2>Estimado usuario. Este es tu informacion introducida</h2>
        </Modal.Header>
        <Modal.Body isCentered className="modal-body">
          <dl>
            <dt>
              <b>Nombre</b>
            </dt>
            <dd>{personalInformation?.fullName || 'Indefinido'}</dd>
            <dt>
              <b>Fecha de nacimiento</b>
            </dt>
            <dd>{personalInformation?.dateOfBirth || 'Indefinido'}</dd>
            <dt>
              <b>Dirección</b>
            </dt>
            <dd>Indefinido</dd> {/* Replace 'Indefinido' with actual field once it is available. */}
            <dt>
              <b>CURP</b>
            </dt>
            <dd>{personalInformation?.CURP || 'Indefinido'}</dd>
            <dt>
              <b>Email</b>
            </dt>
            <dd>{personalInformation?.email}</dd>
          </dl>
        </Modal.Body>
        <Modal.Footer>
          <Button isSlim onClick={() => setShowModal(false)}>
            Entendido
          </Button>
        </Modal.Footer>
      </Modal>
      <ModalError />
      <ModalCreditAnalysis
        showCreditModal={showCreditModal}
        setShowCreditModal={setShowCreditModal}
      />
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_app_dash_personalInformation_banner.png`}
            alt="Finsphera ícono información personal"
          />
        </figure>
        <h2>Información personal</h2>
        <p>
          Bienvenido a FinSphera donde podrás pre calificarte para un crédito desde 500 mil hasta 14
          millones de pesos, sólo es necesario que completes tu registro.
        </p>
      </Banner>
      <Card isForm className="card-container">
        <FormSection>
          <h2>Datos del Apoderado Legal</h2>
          <BiometricsSection>
            <p>
              Para este primer paso, necesitamos que tengas a la mano tu INE para poder validar tus
              datos:
            </p>
            <MetamapButton
              clientid={clientid}
              flowid={flowid}
              metadata={`{"id":"${metadata.id}","typeOfUser":"${metadata.typeOfUser}", "fixedLanguage":"${metadata.fixedLanguage}"}`}
              onUserFinishedSdk={handleMetamapFinish}
              disabled={metamapComplete}
            />
          </BiometricsSection>
          <ContactData>
            <p>
              En este segundo paso, proporciónanos la CIEC o e.firma para continuar con el registro
              de tu solicitud. Después de llenar la información da click en Siguiente.
            </p>
            <Controller
              name="type"
              control={control}
              rules={{ required: 'Es un campo requerido.' }}
              render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => {
                const handleCombinedChange = (value: string | number | readonly string[]) => {
                  handleType(value);
                  onChange(value);
                };

                return (
                  <InputField
                    isDropdown
                    onChangeInternalValue={handleCombinedChange}
                    options={selectOptions}
                    wrapLabel
                    placeholder="Selecciona una opción"
                    errorMessages={error && error.message ? [error.message] : []}
                    {...restFieldProps}
                  />
                );
              }}
            />

            {type === 'ciec' && (
              <>
                <Controller
                  name="RFC"
                  control={control}
                  rules={{
                    required: 'Es un campo requerido.',
                    pattern: {
                      value: /^[A-ZÑ0-9]+$/,
                      message: 'Invalid RFC'
                    },
                    minLength: {
                      value: 12,
                      message: 'RFC debe tener al menos 12 caracteres'
                    }
                  }}
                  render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => (
                    <InputField
                      label="Ingresa tu RFC:"
                      autoUpperCase
                      maxLength={13}
                      onChangeInternalValue={onChange}
                      errorMessages={error && error.message ? [error.message] : []}
                      {...restFieldProps}
                    />
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  rules={{ required: 'Es un campo requerido.' }}
                  render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => (
                    <InputField
                      label="Ingresa tu contraseña:"
                      type="password"
                      onChangeInternalValue={onChange}
                      errorMessages={error && error.message ? [error.message] : []}
                      {...restFieldProps}
                    />
                  )}
                />
              </>
            )}
            {type === 'efirma' && (
              <>
                <Controller
                  name="certificate"
                  control={control}
                  rules={{ required: 'Es un campo requerido.' }}
                  render={({ field: { onChange, name }, fieldState: { error } }) => (
                    <InputUpload
                      label="Certificado (.cer)"
                      id="certificate"
                      accept=".cer"
                      name={name}
                      onChange={(e) => {
                        onChange(e.target.files?.[0]);
                      }}
                      errorMessages={error && error.message ? [error.message] : []}
                    >
                      Subir archivo
                    </InputUpload>
                  )}
                />
                <Controller
                  name="privateKey"
                  control={control}
                  rules={{ required: 'Es un campo requerido.' }}
                  render={({ field: { onChange, name }, fieldState: { error } }) => (
                    <InputUpload
                      label="Llave privada (.key)"
                      name={name}
                      accept=".key"
                      id="private-key"
                      onChange={(e) => {
                        onChange(e.target.files?.[0]);
                      }}
                      errorMessages={error && error.message ? [error.message] : []}
                    >
                      Subir archivo
                    </InputUpload>
                  )}
                />

                <Controller
                  name="RFC"
                  control={control}
                  rules={{
                    required: 'Es un campo requerido.',
                    pattern: {
                      value: /^[A-ZÑ0-9]+$/,
                      message: 'Invalid RFC'
                    },
                    minLength: {
                      value: 12,
                      message: 'RFC debe tener al menos 13 caracteres'
                    }
                  }}
                  render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => (
                    <InputField
                      label="Ingresa tu RFC:"
                      autoUpperCase
                      maxLength={13}
                      onChangeInternalValue={onChange}
                      errorMessages={error && error.message ? [error.message] : []}
                      {...restFieldProps}
                    />
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  rules={{ required: 'Es un campo requerido..' }}
                  render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => (
                    <InputField
                      label="Ingresa tu contraseña:"
                      type="password"
                      onChangeInternalValue={onChange}
                      errorMessages={error && error.message ? [error.message] : []}
                      {...restFieldProps}
                    />
                  )}
                />
              </>
            )}
          </ContactData>
        </FormSection>
        <ConsultCredit>
          <h2>Autorización para consulta en sociedades de información crediticia</h2>
          <div className="checkbox">
            <Checkbox
              label="Acepto los Términos y Condiciones, Aviso de Privacidad y Cláusula de medios electrónicos tales como NIP"
              {...register('termsAndPrivacy', { required: true })}
              boxSize="small"
              errorMessages={
                errors.termsAndPrivacy && [
                  'Por favor acepta los términos y condiciones para continuar.'
                ]
              }
            />
            <div className="checkbox">
              <Checkbox
                label="
                Autorizo expresamente a Sustainable Tech ESG, S.A.P.I de C.V.
                Institución de Financiamiento Colectivo (FinSphera), para que lleve a cabo Investigaciones sobre mi comportamiento Crediticio en las
                Sociedades de Información Crediticia (SIC) que estime conveniente.
                Conozco la naturaleza y alcance de la Información que se solicitará, del uso que se le dará y que se podrán realizar consultas periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento quede bajo propiedad de Sustainable Tech ESG, S.A.P.I de C.V. Institución de Financiamiento
                Colectivo (FinSphera) para efectos de control y cumplimiento del articulo 28 de la LRSIC."
                {...register('authorizationConsultCredit', { required: true })}
                boxSize="small"
                errorMessages={
                  errors.authorizationConsultCredit && [
                    'Esta autorización es requerida para continuar.'
                  ]
                }
              />
            </div>
          </div>
          <p>
            Cláusula para utilizar medios electrónicos de autenticación. Las partes acuerdan que el
            Cliente podrá expresar su consentimiento respecto a los presentes{' '}
            <b>términos y condiciones</b>, así como tener acceso a los servicios ofrecidos por{' '}
            <b>
              Sustainable Tech ESG, S.A.P.I de C.V. Institución de Financiamiento Colectivo
              (FinSphera)
            </b>{' '}
            mediante medios electrónicos tales como NIP.
          </p>
          {showInput ? (
            <div>
              <Controller
                name="finspheraPassword"
                control={control}
                rules={{
                  minLength: {
                    value: 5,
                    message: 'El código debe tener 5 caracteres'
                  },
                  required: 'Código requerido.'
                }}
                render={({ field: { onChange, ...restFieldProps }, fieldState: { error } }) => (
                  <InputField
                    label="Ingreso de NIP que enviamos a tu correo"
                    onChangeInternalValue={onChange}
                    errorMessages={error && error.message ? [error.message] : []}
                    wrapLabel
                    {...restFieldProps}
                  />
                )}
              />
            </div>
          ) : null}
        </ConsultCredit>
      </Card>
      <Container>
        <Button size="small" onClick={closeFlow}>
          Terminar después
        </Button>
        {showInput ? (
          <Button
            size="small"
            type="submit"
            disabled={!metamapComplete}
            onClick={handleSubmit(handleValidateCode)}
          >
            Siguiente
          </Button>
        ) : (
          <Button
            size="small"
            type="submit"
            disabled={!metamapComplete}
            onClick={handleSubmit(onSubmit)}
          >
            Aceptar
          </Button>
        )}
      </Container>
    </PersonalInformationContainer>
  );
}
